import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * OAuth2/OIDC Callback Page
 *
 * This page is displayed briefly while @axa-fr/react-oidc processes
 * the authentication callback from Keycloak. The library automatically
 * handles token exchange and will redirect once complete.
 */
const AuthCallback = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h5" sx={{ mt: 3 }}>
        Completing authentication...
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        Please wait while we sign you in
      </Typography>
    </Box>
  );
};

export default AuthCallback;
